import type { Messages } from '@repere/core';

/**
 * Traduit le motif d'échec rapporté par l'API.
 *
 * Les motifs sont volontairement grossiers côté serveur : dire précisément pourquoi une
 * identité a été refusée à quelqu'un qui n'en est peut-être pas le titulaire lui
 * apprendrait quelque chose sur son propriétaire.
 *
 * Dans son propre module, et non dans l'écran de connexion : les deux chemins de retour
 * s'en servent — l'adresse `?erreur=` du navigateur, et les paramètres que la coque native
 * reçoit du parcours tiers. Les laisser dans l'écran fermait un cycle d'imports entre lui
 * et les boutons de fournisseurs.
 */
export function messageFournisseur(motif: string, m: Messages['entree']['connexion']): string {
  switch (motif) {
    case 'refus':
      return m.echecRefus;
    case 'expire':
      return m.echecExpire;
    default:
      return m.echecGenerique;
  }
}
